'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnquiryQuotesController = function () {
  function EnquiryQuotesController(authService, printService, $ngConfirm, loadingService, fileService, growl, contactService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, EnquiryQuotesController);
    this.authService = authService;
    this.printService = printService;
    this.$ngConfirm = $ngConfirm;
    this.loadingService = loadingService;
    this.fileService = fileService;
    this.growl = growl;
    this.contactService = contactService;
  }

  (0, _createClass3.default)(EnquiryQuotesController, [{
    key: 'checkCanQuote',
    value: function checkCanQuote() {
      var canQuote = false;

      if (this.enquiry.enquiryVehicles.length) {
        var vehicle = (0, _lodash.find)(this.enquiry.enquiryVehicles, function (o) {
          return o.isSelected;
        }).vehicle;

        canQuote = vehicle.price && vehicle.price >= 0;
      }

      if (!canQuote) {
        this.$ngConfirm({
          title: 'ERROR',
          content: 'Cannot quote. Please select a vehicle with a retail price',
          type: 'red',
          typeAnimation: false,
          columnClass: 'm',
          buttons: {
            tryAgain: {
              text: 'Close',
              btnClass: 'btn-danger'
            }
          }
        });
      }

      return canQuote;
    }
  }, {
    key: 'printHtml',
    value: function printHtml() {
      if (!this.checkCanQuote()) {
        return;
      } else {
        this.printService.printQuotation(this.enquiry.enquiryId);
      }
    }
  }, {
    key: 'printPdf',
    value: function printPdf() {
      var _this = this;

      if (!this.checkCanQuote()) {
        return;
      } else {
        this.loadingService.showLoading('enquiryQuotesList', 'Saving Quotation ...');

        this.printService.saveQuotation(this.enquiry.enquiryId, this.authService.authData.userId).then(function (response) {
          _this.enquiry.enquiryQuotes = response.data.data;

          _this.viewSavedQuotation(_this.enquiry.enquiryQuotes[0].enquiryQuoteId);
        }).catch(function (err) {}).finally(function () {
          _this.loadingService.hideLoading('enquiryQuotesList');
        });
      }
    }
  }, {
    key: 'showEmailPdf',
    value: function showEmailPdf() {
      if (!this.checkCanQuote()) {
        return;
      }
      if (!this.enquiry.contactHasEmail) {
        this.$ngConfirm({
          title: 'ERROR',
          content: 'Cannot Email Quote. Contact does not have an email set',
          type: 'red',
          typeAnimation: false,
          columnClass: 'm',
          buttons: {
            tryAgain: {
              text: 'Close',
              btnClass: 'btn-danger'
            }
          }
        });

        return;
      } else {
        this.$ngConfirm({
          title: 'Confirm',
          content: 'Are you sure you want to email quote to the contact ?',
          typeAnimation: false,
          columnClass: 'm',
          buttons: {
            yes: {
              text: 'Email Quote',
              btnClass: 'btn-primary',
              action: this.emailPdf.bind(this)
            },
            no: {
              text: 'Cancel',
              btnClass: 'btn-default'
            }
          }
        });
      }
    }
  }, {
    key: 'emailPdf',
    value: function emailPdf() {
      var _this2 = this;

      this.loadingService.showLoading('enquiryQuotesList', 'Emailing Quotation ...');

      this.printService.emailQuotation(this.enquiry.enquiryId, this.authService.authData.userId).then(function (response) {
        _this2.enquiry.enquiryQuotes = response.data.data;

        _this2.growl.success('Quotation emailed successfully', { ttl: 5000 });
      }).catch(function (err) {}).finally(function () {
        _this2.loadingService.hideLoading('enquiryQuotesList');
      });
    }
  }, {
    key: 'viewSavedQuotation',
    value: function viewSavedQuotation(enquiryQuoteId) {
      this.fileService.getQuotation(enquiryQuoteId);
    }
  }]);
  return EnquiryQuotesController;
}();

exports.default = EnquiryQuotesController;


// WEBPACK FOOTER //
// ./client/app/components/enquiry/enquiryEdit/enquiryQuotes/enquiryQuotes.controller.js